import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["state", "publishDateWrapper", "publishDate", "help", "submit"]
  static values = { initialLabel: String }

  connect() {
    this.update()
  }

  update() {
    const publishSelected = this.stateTarget.value === "published"
    this.publishDateWrapperTarget.hidden = !publishSelected
    if (this.hasHelpTarget) {
      this.helpTarget.textContent = publishSelected && this.publishDateTarget.value
        ? this.helpTarget.dataset.publishedHelp
        : this.helpTarget.dataset.draftHelp
    }
    if (this.hasSubmitTarget) {
      this.submitTarget.value = this.initialLabelValue
    }
  }
}
